<template>
  <div class="card">
    <div class="card-body">
      <h5 class="section-title">{{ __("Gallery") }}</h5>
      <template v-if="loading">
        <Spinner spinner-type="grow" min-height="440px" />
      </template>
      <template v-else>
        <div class="gallery-carousel owl-carousel owl-theme">
          <div
            v-for="galleryImage in galleryImages"
            :key="galleryImage.id"
            class="individual-item"
          >
            <img
              :src="asset_file_url(galleryImage.path)"
              @error="image_load_error"
              class="img-fluid"
              alt="img"
            />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Spinner from "../../components/Spinner";

export default {
  components: {
    Spinner,
  },

  data() {
    return {
      galleryImages: [],
      loading: false,
      observer: null,
    };
  },

  mounted() {
    this.observe_visibility(this.$el, async () => {
      await this.getGalleryImages();
      $(".gallery-carousel").owlCarousel({
        loop: true,
        nav: true,
        items: 1,
        navText: [
          "<i class='fa fa-angle-left'></i>",
          "<i class='fa fa-angle-right'></i>",
        ],
      });
    });
  },

  methods: {
    async getGalleryImages() {
      this.loading = true;
      await axios
        .get("/dashboard/gallery-images")
        .then(({ data }) => (this.galleryImages = data.images))
        .catch(console.error);

      this.loading = false;
    },
  },
};
</script>
